import React from "react";

const ContactMap = () => {
  return (
    <div className="w-full sm:pb-6 md:pb-10">
      {/* Map Section */}
      <div className="w-full relative pb-[56.25%] h-0 overflow-hidden rounded-lg shadow-lg">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3743.21420443202!2d85.79860149999999!3d20.249949200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a74340c770ef%3A0x6462462e9c6de9bf!2z4KS44KWN4KSu4KS-4KSw4KWN4KSfIOCksOCkv-CkquClh-Ckr-CksCDgpKrgpYngpIfgpILgpJ8sIOCkrOClh-CkuOCljeCknyDgpK7gpYvgpKzgpL7gpIfgpLIg4KSr4KWL4KSoIOCksOCkv-CkquClh-Ckr-CksCDgpLjgpY3gpJ_gpYvgpLAs4KSs4KWH4KS44KWN4KSfIOCkruCli-CkrOCkvuCkh-CksiDgpLDgpL_gpKrgpYfgpK_gpLAg4KS24KWJ4KSqLOCkrOClh-CkuOCljeCknyDgpLLgpYjgpKrgpJ_gpYngpKog4KSw4KS_4KSq4KWH4KSv4KSwIOCkuOCljeCkn-Cli-CksCzgpLjgpYDgpLjgpYDgpJ_gpYDgpLXgpYAg4KS44KSw4KWN4KS14KS_4KS4!5e0!3m2!1shi!2sin!4v1750934407046!5m2!1shi!2sin"
          className="absolute top-0 left-0 w-full h-full"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactMap;
